import React from "react";

const UnLock = (props: any) => {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.20785 18.6838H8.0084C7.80851 18.6838 7.60859 18.4838 7.60859 18.2838V13.5838C6.70906 13.1838 6.10938 12.3838 6.10938 11.3838C6.10938 9.98379 7.2088 8.88379 8.60806 8.88379C10.0073 8.88379 11.1068 9.98379 11.1068 11.3838C11.1068 12.3838 10.5071 13.1838 9.60754 13.5838V18.2838C9.50759 18.4838 9.40774 18.6838 9.20785 18.6838ZM8.40822 17.8838H8.80803V13.2838C8.80803 13.0838 8.90791 12.9838 9.1078 12.8838C9.80743 12.6838 10.3072 11.9838 10.3072 11.2838C10.3072 10.3838 9.50759 9.5838 8.60806 9.5838C7.70854 9.5838 6.909 10.3838 6.909 11.2838C6.909 11.9838 7.40869 12.6838 8.10833 12.8838C8.30822 12.8838 8.40822 13.0838 8.40822 13.2838V17.8838Z"
        fill="#FF0054"
      />
      <path
        d="M16.3045 20.5837H0.812587C0.612692 20.5837 0.512695 20.4837 0.512695 20.2837V6.88373C0.512695 6.68373 0.712639 6.58374 0.812587 6.58374H16.3045C16.5043 6.58374 16.6042 6.68373 16.6042 6.88373V20.1837C16.6042 20.3837 16.5043 20.5837 16.3045 20.5837ZM1.2124 19.8837H16.0046V7.28372H1.2124V19.8837Z"
        fill="#FF0054"
      />
      <path
        d="M3.11129 7.18372C2.9114 7.18372 2.81152 7.08373 2.81152 6.88373C2.81152 3.48373 5.51013 0.58374 8.70845 0.58374C10.8073 0.58374 12.7063 1.68374 13.8057 3.58374C13.9057 3.78374 13.8058 3.98374 13.7058 4.08374C13.5059 4.18374 13.306 4.08373 13.2061 3.98373C12.2066 2.28373 10.6075 1.28372 8.70845 1.28372C5.80997 1.28372 3.41118 3.78373 3.41118 6.88373C3.41118 6.98373 3.21124 7.18372 3.11129 7.18372Z"
        fill="#FF0054"
      />
    </svg>
  );
};

export default UnLock;
